import { useEffect } from "react";
import { triggerMobileAppOrStoreRedirect } from "../utils/openAppRedirect";

/**
 * Hook to trigger mobile redirection to native app or Play Store / App Store
 * when viewing an entity (event, club, artist) on mobile browsers.
 */
export default function useMobileStoreRedirect(entityType, entityId) {
  useEffect(() => {
    if (!entityId) return;
    triggerMobileAppOrStoreRedirect({ entityType, entityId });
  }, [entityType, entityId]);
}
